import { Navigate, useLocation } from 'react-router-dom';
import { APICore } from 'helpers/api/apiCore';
import { useUser } from 'hooks';
import { useMemo } from 'react';

const PrivateRoute = ({ component: RouteComponent }: { component: React.ComponentType }) => {
  const location = useLocation();
  const [rawUser] = useUser();
  const loggedInUser = rawUser;

  const api = useMemo(() => new APICore(), []);
  const isAuth = useMemo(() => api.isUserAuthenticated(), [api]);

  if (!isAuth) {
    return <Navigate to="/account/login" state={{ from: location }} replace />;
  }

  // Apenas tipo 1 segue com layout padrão
  if (loggedInUser?.type === 1) {
    return <RouteComponent />;
  }

  // Redireciona outros para rota deles
  return <Navigate to="/txclmt/upload" replace />;
};

export default PrivateRoute;
